import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { applicationClearState } from 'reducers/application/reducer'
import ApplicationList from './ApplicationList'
import ApplicationItem from './ApplicationItem'

function Application(props) {
  const {
    match: {
      params: { id },
    },
    applicationClearState,
  } = props
  const Content = id ? ApplicationItem : ApplicationList

  useEffect(
    () => () => {
      applicationClearState()
    },
    [],
  )

  return (
    <div className="content">
      <Content {...props} />
    </div>
  )
}

Application.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  applicationClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  applicationClearState,
})(Application)
